// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"76badd34","243":"23884b98","282":"06c953a7","289":"ff2160b9","502":"3ef04a48","642":"c5a1ff7a"}[chunkId] + ".chunk.js";
};